export { default } from './RoomSidebarBlock';



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomSidebarBlock/index.js